module.exports = __webpack_public_path__ + "static/media/3.eea606d9.JPG";